<template>
  <form @submit.prevent="onSubmit()">
    <div class="row">
      <div class="col-12 d-flex align-items-end">
        <div class="app-radio" required>
          <label>Tipo:</label>
          <div class="app-radio__options">
            <b-radio
              v-for="type in recipientTypeLabel"
              :key="type[0]"
              v-model="data.type"
              :native-value="type[0]"
              >{{ type[1] }}</b-radio
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <app-input
          label="E-mail"
          required
          v-model="data.email"
          :errors="errors.email"
        ></app-input>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button type="submit" :disabled='saving' v-app-button>Salvar</button>
      </div>
    </div>
  </form>
</template>

<script>
import {
  FormRecipientsTypeEnum,
  FormRecipientsTypeLabel,
} from '@/enums/FormRecipientsEnum';
import { required, email } from 'vuelidate/src/validators';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'form-recipient-form',
  mixins: [ToastMixin],
  props: ['errors', 'saving'],
  data: () => {
    return {
      recipientTypeLabel: Array.from(FormRecipientsTypeLabel),
      data: {
        email: null,
        type: FormRecipientsTypeEnum.CONTACT,
      },
    };
  },
  validations: {
    data: {
      emails: { required, email },
      type: { required },
    },
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  display: block;
  text-transform: uppercase;
  font-weight: bolder;
  color: #363636;
  font-size: 0.95em;
  margin-bottom: 3px;

  span {
    font-weight: normal;
  }
}

.information {
  position: relative;
  top: -10px;
  font-size: 14px;
  font-style: italic;
}
</style>
